import React, { useState, useEffect } from "react";
import SearchIcon from '@mui/icons-material/SearchTwoTone';
import _ from "lodash";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ApiAmusementTestimonial from "../../../core/api/api.amusementTestimonials";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { AddEditeModal } from "./AddEditeModal";
import SelectComponent from "../_Components/ReactSelectComponent";
import { InputGroup, Button, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl";
import ApiAmusementComplex from "../../../core/api/api.amusementComplex";


const Testimonial = () => {
  const [listData, setListData] = useState({});
  const { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch, reset } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [showModalTestimonial, setShowModalTestimonial] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);
  const [amusementServiceList, setAmusementServiceList] = useState([]);
  const [amusementComplexList, setAmusementComplexList] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);

  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;

  useEffect(() => {
    (async () => {
      try {
        // دریافت لیست نظرات های کاربر
        const data = await ApiAmusementTestimonial.getAmusementTestimonials({
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const apiData = await ApiAmusementService.getAllServices();
        setAmusementServiceList(apiData);

        const apiData2 = await ApiAmusementComplex.getAmusementComplexes();
        setAmusementComplexList(apiData2);
        const formInputs = [
          { name: "amusementServiceId", type: "multiSelect", isMulti: true, data: apiData },
          { name: "amusementComplexId", type: "multiSelect", isMulti: true, data: apiData2 },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmit =
    async (data) => {
      data.amusementServiceId = data.amusementServiceId?.value;
      data.amusementComplexId = data.amusementComplexId?.value;
      const apiData = await ApiAmusementTestimonial.getAmusementTestimonials({
        pageSize: data.pageSize, pageNumber: getValues("pageNumber"),
        amusementServiceId: _.toString(data.amusementServiceId),
        amusementComplexId: _.toString(data.amusementComplexId),
        globalSearch: data.globalSearch
      });

      setListData(apiData);
      setValue("totalCount", apiData.totalCount);
      tools.setPageNumber(data, searchParams, setValue);
      var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
      navigate(`/testimonials?${queryString}`);
    }


  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              مدیریت نظرات
                        </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لیست نظرهای ثبت شده
                        </span>
          </h3>
          <div className="card-toolbar">
            {/* <Button variant="success" onClick={handleShow}>
                     <AddCircle className='mr-1' />
                      ایجاد درگاه جدید
             </Button> */}
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods} >
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className='border-top pt-3'>
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body className="px-0">
                        <Row>
                          <Col sm="6" xl="3">
                            <Controller
                              name="amusementServiceId"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-100 mt-5"
                                  placeholder="انتخاب تفریح"
                                  options={amusementServiceList?.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                    type: "service",
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3">
                            <Controller
                              name="amusementComplexId"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-100 mt-5"
                                  placeholder="انتخاب مجموعه"
                                  options={amusementComplexList?.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                    type: "complex",
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="auto" className=" px-2 mt-3">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                          </Col>
                          <Col xs="auto" className=" px-2 mt-3">
                            <Button
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                            >
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <i className="fas fa-refresh text-small"></i>
                                حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder='جستجو ...'
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}><SearchIcon /></Button>

                </InputGroup>
              </div>
              {/* table */}
              <Col xs='12' className='tb-reponsive px-0'>
                <DataGrid data={listData} setShowModalTestimonial={setShowModalTestimonial} setSelectedTestimonial={setSelectedTestimonial} />
              </Col>
              {showModalTestimonial && (
                <AddEditeModal
                  showModalTestimonial={showModalTestimonial}
                  setShowModalTestimonial={setShowModalTestimonial}
                  selectedTestimonial={selectedTestimonial}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;